<template>
	<div class="destroy">
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<span>注销账号</span>
			<div></div>
		</div>
		<!-- 注销原因 -->
		<div class="content">
			<div class="content_title">
				注销后,您将放弃以下权益：
			</div>
			<div class="content_main">
				1.您的所有交易记录将被清空,请确保所有交易已完结且无纠纷,账户注销后因历史交易可能产生的换货维修相关资金的退回等权益将视作自动放弃
				<br />
				2.您的身份信息、账户信息等相关权益将被清空且无法恢复。
			</div>
			<div class="content_title">
				注销,您需要满足以下条件：
			</div>
			<div class="content_main">
				1.账户相关资金已结清,清零。
				<br />
				2.账户近期不存在交易。
				<br />
				3.账户无未完结的服务。
			</div>
		</div>
		<button @click="destroy">确定注销</button>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		methods: {
			destroy() {
				let that = this;
				that.$dialog.confirm({
					message: '您确定要注销吗？'
				}).then(() => {
					that.$axios.post(baseUrl + '/mobile/User/userCancellation', {
						token: localStorage.getItem('Authorization')
					}).then(function (res) {
						if (res.data.code == 1009) {
							localStorage.removeItem('Authorization');
							that.$toast(res.data.msg);
							setTimeout(function () {
								that.$router.push({
									path: '/Home'
								})
							}, 1000)
						}
					}).catch(function (err) {
						console.log(err);
					});
				}).catch(() => { });
			}
		}
	}
</script>

<style scoped>
	.destroy {
		padding-top: 2rem;
	}

	.destroy .content {
		text-align: left;
		padding: 0 1rem;
		box-sizing: border-box;
	}

	.destroy .content_title {
		color: #F1452F;
		margin: 1rem 0;
		font-weight: bold;
	}

	.destroy .content_main {
		font-size: 0.8rem;
		background: #fff;
		border-radius: 0.5rem;
		padding: 0.7rem 0.3rem;
		color: #666;
		line-height: 1.8rem;
		box-sizing: border-box;
	}

	.destroy button {
		margin-top: 3rem;
		width: 12rem;
		height: 2rem;
		line-height: 2rem;
		color: #fff;
		font-size: 0.9rem;
		border-radius: 1rem;
		border: 0;
		background: #F1452F;
	}
</style>


// WEBPACK FOOTER //
// src/components/min/setting/destroy.vue